import React from "react";
import PropTypes from "prop-types";

const Section = (props) => {
	let sectionclassName = props.color ? "c-section ia c-section--" + props.color : "c-section ia";
	sectionclassName = props.disabled ? sectionclassName + " disabled" : sectionclassName;
	const header = props.title ? (
		<header className="c-section__header">
			<h3 className="title">{props.title}</h3>
		</header>) : null;
	return (
		<div className="c-section-wrap">
			<div className={sectionclassName}>
				{header}
				<div className="c-section__body">
					{props.children}
				</div>
			</div>
		</div>
	);
};

Section.propTypes = {
	title: PropTypes.string,
	color: PropTypes.string,
	children: PropTypes.node,
	disabled: PropTypes.bool
};

export default Section;
